import { getLocalStorageData } from "../../utils/LocalStorageService";
import "./home.scss"
import { DatePicker } from "antd";

const { RangePicker } = DatePicker;

type Props = {};

const Home = (props: Props) => {

    return (
        <div>
            <div className="fw-bold fs-4 mt-2 text-center">
                Welcome to Passion - Project Management
            </div>
        </div>
    );
};

export default Home;